export default __webpack_public_path__ + "2f22fabdcaf897f277217fce0906d36e.svg";